<template lang="pug">
div

  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-labs.is-widescreen-4.is-tablet-4
      .column.u-mb-sm(v-for="item in $t('sec1Items')")
        h3: AppLink(:to="item.url" :title="item.title") {{item.title}}
        p {{item.desc}}
        .u-mt-ts
          AppLink(:to="item.url" title="$t('explore')" class="button-link is-small") {{$t('explore')}}

  .u-divider.u-mt-sm
  section.u-mt-md
    .grid.is-labs.is-ultrawide-6.is-widescreen-7.is-desktop-9.is-center
      .column
        h3 {{$t('knowledge')}}


  section.u-mt-md
    .grid.is-small.is-middle
      .column.is-desktop-6
        AppCard.is-large( :img="[{ srcset: '{CDN_URL}/default@2x.webp 2x, {CDN_URL}/default.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/default@2x.png 2x, {CDN_URL}/default.png 1x', type: 'image/png' }]" :excerpt="$t('resourcesDesc')" ratio="2:1" :title="$t('resources')" url="/resources")
      .column.is-desktop-1
      .column.is-desktop-4
        AppCard.is-large( :img="[{ srcset: '{CDN_URL}/academy@2x.webp 2x, {CDN_URL}/academy.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/academy@2x.png 2x, {CDN_URL}/academy.png 1x', type: 'image/png' }]" :excerpt="$t('academyDesc')" ratio="1:1" :title="$t('academy')" url="/academy")
      .column.is-desktop-1


  .u-mt-md
    .grid.is-labs.is-ultrawide-6.is-widescreen-7.is-desktop-9.is-center
      .column
        Homer
  .u-mb-md
</template>

<script>
import Homer from '~/components/Homer';
import { Events } from '~/graphql/Event.gql';
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  meta: {
    logoText: 'labs',
    theme: 'is-labs'
  },

  head: generateSeoMeta(
    {
      title: 'title',
      description: 'description',
      image: 'shareImage'
    },
    { i18n: true }
  ),

  components: {
    Homer
  },
  async asyncData({ app }) {
    try {
      const { data } = await app.$api.query({
        query: Events,
        variables: {
          first: 3,
          filters: {
            time: 'upcoming',
            type: 'conference',
            scopes: ['CODE', 'DESIGN', 'TECH', 'BUSINESS']
          }
        }
      });

      return {
        events: data.events.edges.map(e => e.node)
      };
    } catch (err) {
      console.error(err.message);

      return {
        events: []
      };
    }
  }
};
</script>

<style lang="stylus">
.baseItems
  display: flex
  height: 1000px

  a
    display: flex
    padding: unitRes(40, 80)
    justify-content: flex-end
    flex-direction: column

  p
    max-width: 80%

  &-col
    flex: 0 0 50%
    width: 50%
    height: 100%

  &-1
    background: #eaed46
    height: 50%

    &:hover
      color: $clBlack

  &-2
    background: #0174f5
    height: 50%
    color: $clWhite

    &:hover
      color: $clWhite

  &-3
    background: #fe224e
    height: 100%
    color: $clWhite

    &:hover
      color: $clWhite

.app.is-labs
  overflow: hidden

  .hide-desktop
    +mq($until: 'desktop')
      display: none

  .show-desktop
    +mq($from: 'desktop')
      display: none
</style>

<i18n>
{
  "en": {
    "title":"Baianat Labs",
    "description":"Baianat Labs aim to spread awareness and support the community with inspiring material in design, business,code and technology.",
    "shareImage":"/share/labs.png",
    "mantra": "The outputs of |curiosity.",
    "business":"Business",
    "businessDesc":"Strategy, Planning, Innovation, Business, Marketing, Story telling, Social media.",
    "design":"Design",
    "designDesc":"Product Design, User experience, Interaction, Design systems, Typography",
    "code":"Development",
    "codeDesc":"Development, Open source, Frameworks, Plugins, Artificial intelligence.",
    "technology":"Technology",
    "technologyDesc":"Artificial Intelligence, IoT, Extended Reality, Robotics, Big Data and Analytics.",
    "explore":"Explore",
    "upcomingEvents":"Upcoming |Events.",
    "knowledge":"Knowledge is not exclusive so Labs aim to spread awareness and support the community with inspiring insights.",
    "seeders":"Seeders",
    "seedersDesc":"Help us spread awareness starting with your own circles then to the whole world.",
    "careers":"Do what you love most with people who share you the same passion.",
    "careersCta":"Join the family",
    "brand":"Brand",
    "brandDesc":"Design system that makes innovation and accelerates your design and development processes.",
    "fonts":"Typefaces",
    "fontsDesc":"Make beautiful designs using fonts that blend smoothly with your identity.",
    "sec1Items":{
      "1":{
        "title":"Insights",
        "desc":"Innovating solutions for business dilemmas and coming up with our own theories.",
        "url":"/insights"
      },
      "2":{
        "title":"Backstage",
        "desc":"Explore the development of our design work and see how we scale projects.",
        "url":"/backstage"
      },
      "3":{
        "title":"Experiments",
        "desc":"Sharing our code projects with unique functionalities and concepts.",
        "url":"/experiments"
      }
    },
    "tools":"Tools",
    "toolsDesc":"Variety of handy tools to help you get your work done faster. Use it online and download the results in the format your prefer.",
    "resources":"Resources",
    "resourcesDesc":"Materials and inspirations created based on experience to support you in making your next big project.",
    "openSource":"Open source",
    "openSourceDesc":"Baianat libraries created to support developers in their coding process and cut off the time needed for mobile or web development processes.",
    "panorama":"Panorama",
    "egyptos":"Egyptos",
    "gridMaker":"Grids",
    "aspectRatio":"Ratios",
    "spectrum":"Spectrum",
    "quotes":"Quotes",
    "posters":"Posters",
    "stark":"Stark",
    "large":"Large",
    "align":"Align",
    "board":"Board",
    "academy":"Academy",
    "academyDesc":"Learning paths in design, business, development and technology.",
    "events":"Events",
    "eventsDesc":"To transmit our messages and better engage with the community, we created events through which we can meet you face to face."
  },
  "ar": {
    "title":"مختبرات بيانات",
    "description":"تهدف مختبرات إلى نشر الوعى ودعم المجتمع بأفكار ومقالات ملهمة في مجالات التصميم والبرمجة والتكنولوجيا والأعمال التجارية.",
    "shareImage":"/share/labs.png",
    "mantra": "دوافع مختلفة |للابتكار.",
    "business":"بيزنس",
    "businessDesc":"الاستراتيجية و التخطيط و الابتكار و الأعمال التجارية والتسويق ورواية القصص ووسائل التواصل الإجتماعي.",
    "design":"تصميم",
    "designDesc":"تصميم المنتجات، وتجربة المستخدم، والتصميمات التفاعلية، وأنظمة التصميم، والتايبوغرافي وتصميم الهوية التجارية.",
    "code":"برمجة",
    "codeDesc":"برمجة المواقع والتطبيقات والحلول البرمجية والمصادر المفتوحة والإضافات وإطارات العمل والذكاء الإصطناعي.",
    "technology":"تكنولوجيا",
    "technologyDesc":"الذكاء الاصطناعي و إنترنت الأشياء والآلية و البيانات الضخمة والتحليلات والواقع المعزز والواقع الافتراضي.",
    "explore":"اكتشف",
    "upcomingEvents":"فعاليات وأحداث |قادمة. ",
    "knowledge":"المعرفة لا تقتصر على أحد بعينه؛ لذا تهدف مختبرات بيانات إلى نشر الوعي التقني من خلال رؤى مُلهمة.",
    "seeders":"الناشرون",
    "seedersDesc":"ساعدنا على نشر الوعي بداية من دائرة معارفك الخاصة ومن ثم العالم بأسره.",
    "careers":"اختار ما تودّ فعله و تواصل مع الأشخاص الذين لديهم نفس شغفك وحماسك. ",
    "careersCta":"انضم إلى عائلتنا",
    "brand":"العلامة التجارية",
    "brandDesc":"نظام التصميم الذي يمنحك مزيدًا من الابتكار ويسرع عمليات التصميم والبرمجة الخاصة بك.",
    "fonts":"الخطوط",
    "fontsDesc":"اصنع تصميمات جميلة باستخدام خطوط تتماشى بسلاسة مع هويتك.",
    "sec1Items":{
      "1":{
        "title":"الرؤى",
        "desc":"نقدم حلول مبتكرة من أجل مشكلات الأعمال التجارية التي تواجه الجميع وكذلك التوصل إلى نظرياتنا الخاصة. ",
        "url":"/insights"
      },
      "2":{
        "title":"الكواليس",
        "desc":"استكشف كيف نعمل على تطوير أعمال التصميم الخاصة بنا وشاهد كيف نغير من نطاق المشروعات.",
        "url":"/backstage"
      },
      "3":{
        "title":"التجارب",
        "desc":"نشارك مشاريع البرمجة الخاصة بنا مع وظائف وأفكار جديدة.",
        "url":"/experiments"
      }
    },
    "tools":"الأدوات",
    "toolsDesc":"مجموعة متنوعة من الأدوات التي تساعدك على إنجاز أعمالك بشكل أسرع. استخدمها عبر الانترنت ثم قم بتحميل النتائج على الفور.",
    "resources":"المصادر",
    "resourcesDesc":"الإلهامات والمواد التي توصلنا إليها بناءً على خبراتنا في المجال من أجل دعمك في إنشاء مشروعك القادم ",
    "openSource":"المصادر المفتوحة",
    "openSourceDesc":"تم إنشاء المصادر المفتوحة من أجل دعم المبرمجين في عملياتهم وتقليل الوقت والمجهود سواء لمبرمجى التطبيقات أو الويب.",
    "panorama":"بانوراما",
    "panoramaDesc":"شاهد العالم من وجهة نظر بيانات. القِ نظرة أكثر تفصيلًا على المعالم المختلفة التي أعدنا رسمها رقميًا.",
    "egyptos":"ايجيبتوس",
    "egyptosDesc":"شاهد جمال مصر من خلال رسمنا لمدنها ومعالمها المهمة باستخدام هوية مميزة تجمع ما بين الماضي والحاضر.",
    "gridMaker":"الشبكات",
    "aspectRatio":"النسب",
    "spectrum":"سبكترام",
    "quotes":"الاقتباسات",
    "posters":"البوسترات",
    "stark":"ستارك",
    "large":"لارج",
    "align":"Align",
    "board":"Board",
    "academy":"الأكاديمية",
    "academyDesc":"مسارات التعلم في التصميم والأعمال التجارية والبرمجة والتكنولوجيا.",
    "events":"الفعاليات",
    "eventsDesc":"من أجل نقل رسائلنا وخبراتنا وجهًا لوجه مع الجميع أنشأنا الفعاليات الخاصة بنا لمزيد من التواصل مع المجتمع."
  }

}
</i18n>
